export default __webpack_public_path__ + "static/media/019-idea.c13c3bac.svg";